import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class BankAccountLineAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'BankAccountLineAllocation';

}
